interface SecuritySVGProps {
  color?: string;
}

const SecuritySVG: React.FC<SecuritySVGProps> = ({ color = "#4F46E5" }) => {
  return (
    <svg
      viewBox="0 0 400 300"
      className="w-full h-full transform transition-transform duration-300 rounded-lg"
    >
      <defs>
        <linearGradient
          id="security-gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" stopColor={color} stopOpacity="0.1" />
          <stop offset="100%" stopColor={color} stopOpacity="0.05" />
        </linearGradient>
        <filter id="security-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
          @keyframes rotate-shield {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse-shield {
            0% { transform: scale(1); opacity: 0.6; }
            50% { transform: scale(1.02); opacity: 0.7; }
            100% { transform: scale(1); opacity: 0.6; }
          }
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-2px); }
            100% { transform: translateY(0px); }
          }
          .rotate-shield { animation: rotate-shield 30s linear infinite; }
          .pulse-shield { animation: pulse-shield 8s ease-in-out infinite; }
          .float { animation: float 10s ease-in-out infinite; }
        `}
      </style>

      {/* Background */}
      <rect width="400" height="300" fill="url(#security-gradient)" />

      <g className="float">
        {/* Outer rotating ring */}
        <g className="rotate-shield" style={{ transformOrigin: "200px 150px" }}>
          {[...Array(12)].map((_, i) => {
            const angle = (i * 30 * Math.PI) / 180;
            const x = 200 + Math.cos(angle) * 80;
            const y = 150 + Math.sin(angle) * 80;
            return (
              <circle
                key={i}
                cx={x}
                cy={y}
                r="3"
                fill={color}
                opacity="0.2"
                className="transition-colors duration-500"
              />
            );
          })}
        </g>

        {/* Shield layers */}
        <g className="pulse-shield" filter="url(#security-glow)">
          {/* Outer shield */}
          <path
            d="M200 80 L260 100 L260 180 C260 220 200 240 200 240 C200 240 140 220 140 180 L140 100 Z"
            fill={color}
            opacity="0.1"
            className="transition-colors duration-500"
          />

          {/* Middle shield */}
          <path
            d="M200 90 L250 107 L250 175 C250 210 200 227 200 227 C200 227 150 210 150 175 L150 107 Z"
            fill={color}
            opacity="0.15"
            className="transition-colors duration-500"
          />

          {/* Inner shield */}
          <path
            d="M200 100 L240 114 L240 170 C240 200 200 214 200 214 C200 214 160 200 160 170 L160 114 Z"
            fill={color}
            opacity="0.2"
            className="transition-colors duration-500"
          />
        </g>

        {/* Central icon */}
        <g className="pulse-shield" style={{ animationDelay: "0.5s" }}>
          <circle
            cx="200"
            cy="150"
            r="20"
            fill={color}
            opacity="0.15"
            className="transition-colors duration-500"
          />
          <circle
            cx="200"
            cy="150"
            r="15"
            fill={color}
            opacity="0.2"
            className="transition-colors duration-500"
          />
        </g>

        {/* Decorative elements */}
        {[0, 120, 240].map((angle, i) => (
          <path
            key={i}
            d={`M${200 + Math.cos((angle * Math.PI) / 180) * 100} ${
              150 + Math.sin((angle * Math.PI) / 180) * 100
            } A 100 100 0 0 1 ${
              200 + Math.cos(((angle + 60) * Math.PI) / 180) * 100
            } ${150 + Math.sin(((angle + 60) * Math.PI) / 180) * 100}`}
            fill="none"
            stroke={color}
            strokeWidth="1"
            opacity="0.1"
            strokeDasharray="4,4"
            className="transition-colors duration-500"
          />
        ))}
      </g>
    </svg>
  );
};

export default SecuritySVG;
